<template>
    <div>
        <div class="text-center">
            <h3 class="mx-auto bg-info text-center" style="width: 85%">{{skillArea}}</h3>
            <b-img center fluid v-on:click="driveFocus(false)" class="img-style" :alt="skillArea"
                       :src="require('../assets/imgs/skill-area/' + skillArea + '.png')"/>
        </div>
        <transition name="slide-fade" mode="out-in">
            <div v-if="focus" class="mx-auto" style="width: 85%">
                <b-list-group>
                    <b-card v-if="skills" no-body>
                        <b-list-group horizontal="md" class="text-center" v-for="skill in skills" v-bind:key="skill.name" flush>
                            <b-list-group-item>
                                <b>{{skill.name}}</b>
                                <b-img center fluid v-on:click="focus = !focus" class="img-item-style" :alt="skill.name"
                                       :src="getSkillImage(skill.name)"/>
                                <br/>
                                <b>Level of expertise:</b>
                                <br/>
                                {{skill.expertise}}
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>

                </b-list-group>
                <b-button v-on:click="driveFocus(true)" style="width: 100%">Collapse</b-button>
            </div>
        </transition>
        <br/>
    </div>
</template>

<script>
    export default {
        name: "Job",
        props: {
            skillArea: {
                required: true,
                type: String
            },
            skills: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                focus: false,
                beforeScroll: 0
            }
        },

        methods: {
            driveFocus (buttonPress) {
                this.focus = !(this.focus);
                if (!this.focus && buttonPress) {
                    window.scrollTo(0, this.beforeScroll)
                } else {
                    this.beforeScroll = window.scrollY;
                }

            },
            getSkillImage(skillName) {
                try {
                    return require('../assets/imgs/skill/' + skillName + '.png');
                } catch (e) {
                    try {
                        return require('../assets/imgs/skill/' + skillName + '.jpg');
                    } catch (e2) {
                        return require('../assets/imgs/skill/' + skillName + '.PNG');
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
